// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".service-name[data-v-772ec187],\n.manage-text[data-v-772ec187] {\n  color: #4998c8;\n}\n.entity-subtitle[data-v-772ec187] {\n  font-size: 9px;\n  color: #A6A4A6;\n}\n.expanded-item[data-v-772ec187] {\n  background: #fafafa;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
